// extracted by mini-css-extract-plugin
export default {"container":"ContactPill_container__fWJlF","icon_container":"ContactPill_icon_container__zM8+V","text":"ContactPill_text__R2HBe"};